import { render, staticRenderFns } from "./XButton.vue?vue&type=template&id=94236608"
import script from "./XButton.vue?vue&type=script&lang=js"
export * from "./XButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports